import gql from 'graphql-tag'

export const CREATE_CONDITION_MANAGEMENT_M = gql`
  mutation CreateConditionManagement($input: CreateConditionManagementInput!) {
    createConditionManagement(input: $input) {
      code
      success
      message
      conditionManagement {
        id
        assets {
          conditionalContentId
        }
      }
    }
  }
`

export const UPDATE_CONDITION_MANAGEMENT_M = gql`
  mutation UpdateConditionManagement($id: String!, $input: UpdateConditionManagementInput!) {
    updateConditionManagement(id: $id, input: $input) {
      code
      success
      message
      conditionManagement {
        id
        assets {
          conditionalContentId
        }
      }
    }
  }
`

export const DELETE_CONDITION_MANAGEMENT_M = gql`
  mutation DeleteConditionManagement($id: String!) {
    deleteConditionManagement(id: $id) {
      code
      success
      message
    }
  }
`
